import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteDrugGroup,
    getAllDrugGroup,
    getDrugGroupById,
    pagingDrugGroup,
    saveDrugGroup
} from 'app/services/DrugGroupService';
import { DrugGroup } from "app/common/Model/DrugGroup";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class DrugGroupStore {
    listAllDrugGroup = [];
    searchDrugGroup = new SearchObject();
    pageDrugGroup = null;
    selectedDrugGroup = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteDrugGroup = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllDrugGroup = () => {
        if (this.listAllDrugGroup?.length === 0 || this.recentlyUpdated) {
            getAllDrugGroup()
                .then(({ data }) => {
                    this.listAllDrugGroup = data;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingDrugGroup = async () => {
        return await pagingDrugGroup(this.searchDrugGroup)
            .then(({ data }) => {
                this.pageDrugGroup = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchDrugGroup) => {
        this.searchDrugGroup = checkSearchObject(this.searchDrugGroup, searchDrugGroup);
        this.pagingDrugGroup();
    }

    handleOpenFormCreateOrEdit = (drugGroupId) => {
        if (Boolean(drugGroupId)) {
            getDrugGroupById(drugGroupId)
                .then(({ data }) => {
                    this.selectedDrugGroup = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedDrugGroup = new DrugGroup();
            this.openFormCreateOrEdit = true;
        }
    }

    saveDrugGroup = async (drugGroup, { setSubmitting }) => {
        return await saveDrugGroup(drugGroup)
            .then(() => {
                this.recentlyUpdated = true;
                this.selectedDrugGroup = null;
                toast.success("Lưu nhóm thuốc thành công!");
                this.handleClosePopup();
                this.pagingDrugGroup();
            })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin nhóm thuốc có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteDrugGroup = (drugGroup) => {
        this.selectedDrugGroup = { id: drugGroup?.id };
        this.openConfirmDeleteDrugGroup = true;
    }

    handleConfirmDeleteDrugGroup = () => deleteDrugGroup(this?.selectedDrugGroup?.id)
        .then(() => {
            if (this.searchDrugGroup.pageIndex > 1 && this.pageDrugGroup?.content?.length === 1) {
                this.searchDrugGroup.pageIndex -= 1;
            }
            toast.success("Xóa nhóm thuốc thành công!")
            this.handleClosePopup();
            this.recentlyUpdated = true;
            this.pagingDrugGroup();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa nhóm thuốc có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteDrugGroup = false;
    }

    resetStore = () => {
        this.searchDrugGroup = new SearchObject();
        this.pageDrugGroup = null;
        this.selectedDrugGroup = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteDrugGroup = false;
    }
}